.legend {
    display: inline-flex;
    flex-direction: column;
    gap: var(--tempest-space-1);
    padding: var(--tempest-space-2) var(--tempest-space-3);
    background: var(--tempest-surface);
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-radius-md);
    font-family: var(--tempest-font-sans);
    font-size: var(--tempest-text-xs);
    color: var(--tempest-text);
    min-width: 160px;
}

.title {
    font-weight: var(--tempest-weight-semibold);
    font-size: var(--tempest-text-sm);
}

.gradient {
    height: 10px;
    border-radius: var(--tempest-radius-sm);
    border: 1px solid var(--tempest-border);
}

.ticks {
    display: flex;
    justify-content: space-between;
    color: var(--tempest-text-muted);
}

.items {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--tempest-space-1);
}

.item {
    display: flex;
    align-items: center;
    gap: var(--tempest-space-2);
}

.swatch {
    width: 14px;
    height: 14px;
    border-radius: var(--tempest-radius-sm);
    border: 1px solid var(--tempest-border);
    flex: none;
}

.itemLabel {
    color: var(--tempest-text-muted);
}
